module.exports = __webpack_public_path__ + "static/media/banner-homepage_video.d51e7f1e.jpg";